import { PredictionPublicationPrice } from "@domains/VIM/interfaces/interfaces";

export const getPublicationPrice = (
  defaultPublicationPrice: number,
  selectedOption: PredictionPublicationPrice | null,
  suggestionOption: PredictionPublicationPrice | null,
): number => {
  if (selectedOption) return selectedOption.precio_nuevo;
  if (suggestionOption) return suggestionOption.precio_nuevo;

  return defaultPublicationPrice;
};
